// translations.js
const translations = {
    en: {
        home: "Home",
        about: "About",
        contactUs: "Contact Us",
        experience: "Experience",
        chatNow: "Chat Now",
        legalAI: "LegalAI",
        innovatingLegal: "Innovating Legal Assistance with AI",
        legalGoal: "Our goal is to make legal knowledge accessible.",
        clickForChat: "Click on me for personalized chat!",
        aboutHead: "About LegalAI",
        aboutDescription: "This project, born out of a Hackathon initiative, aims to revolutionize legal assistance by making it more accessible and efficient through the power of AI.",
        
        goal:"Our goal is to make legal knowledge accessible, reliable, and efficient for everyone, by utilizing the latest advancements in AI technology.",
        join: "Join us on our mission to revolutionize the legal landscape by providing free access to high-quality legal assistance.",

        goalHead: "Our Goal",
        goalDescription: "To democratize legal information by providing AI-driven solutions, ensuring that everyone has access to accurate and timely legal assistance, regardless of their background.",

        detailsHead: "Hackathon Details",
        detailsDescription: "We recently participated in a 48-hour hackathon, developing an AI-powered chatbot designed to provide quick legal advice. This project showcases our commitment to leveraging technology to make legal assistance accessible.",

        team: "Meet the Team",
        studentsHeader: "LegalAI for students",
        individualsHeader: "LegalAI for individuals",

        individuals:"LegalAI can provide instant access to legal information, helping individuals understand their rights and responsibilities. Whether it's a question about family law, tenant rights, or personal injury claims, LegalAI offers reliable guidance to help users navigate their legal situations effectively. This empowers individuals to make informed decisions without the stress of prolonged legal consultations.",
    },
    es: {
        home: "Inicio",
        about: "Acerca de",
        contactUs: "Contáctenos",
        chatNow: "Chatear ahora",
        legalAI: "LegalAI",
        experience: "Experiencia",
        innovatingLegal: "Innovando la asistencia legal con IA",
        legalGoal: "Nuestro objetivo es hacer que el conocimiento legal sea accesible.",
        clickForChat: "¡Haz clic en mí para un chat personalizado!",
        aboutHead: "Acerca de LegalAI",
        aboutDescription: "Este proyecto, nacido de una iniciativa de Hackathon, tiene como objetivo revolucionar la asistencia jurídica haciéndola más accesible y eficiente gracias al poder de la IA.",

        goal: "Nuestro objetivo es hacer que el conocimiento jurídico sea accesible, confiable y eficiente para todos, mediante la utilización de los últimos avances en tecnología de inteligencia artificial." ,
        join: "Únase a nosotros en nuestra misión de revolucionar el panorama legal brindando acceso gratuito a asistencia legal de alta calidad." ,

        goalHead: "Nuestro objetivo",
        goalDescription: "democratizar la información legal brindando soluciones impulsadas por inteligencia artificial, garantizando que todos tengan acceso a asistencia legal precisa y oportuna, independientemente de sus antecedentes.",

        detailsHead: "Detalles del hackatón",
        detailsDescription: "Recientemente participamos en un hackathon de 48 horas, desarrollando un chatbot con tecnología de inteligencia artificial diseñado para brindar asesoramiento legal rápido. Este proyecto muestra nuestro compromiso de aprovechar la tecnología para hacer que la asistencia legal sea accesible.",
        team:"Conoce al equipo",
        studentsHeader:"IA legal para estudiantes",

        individualsHeader: "IA legal para particulares",
        individuals:"LegalAI puede proporcionar acceso instantáneo a información legal, ayudando a las personas a entender sus derechos y responsabilidades. Ya sea una pregunta sobre derecho familiar, derechos de los inquilinos o reclamos por lesiones personales, LegalAI ofrece orientación confiable para ayudar a los usuarios a navegar sus situaciones legales de manera efectiva. Esto empodera a las personas para que tomen decisiones informadas sin el estrés de consultas legales prolongadas.",
    },
};

export default translations;
